import React, { PureComponent, Fragment } from 'react';
import Classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StandardPerformanceTable from 'wt-react/dist/components/StandardPerformance/StandardPerformanceTable.js';
import DetailsTable from 'wt-react/dist/components/StandardPerformance/DetailsTable.js';
import MorningstarTable from 'wt-react/dist/components/StandardPerformance/MorningstarTable.js';
import i18n from '../../i18n.js';
import './FundHighlights.css';

// Import an example fund
// import exampleFunds from '../../examplefund.json';

class FundHighlights extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            showTab: 'ratings',
        };

        this.handleChangeTable = this.handleChangeTable.bind(this);
    }

    formatDate(dateString) {
        return (
            dateString && (new Date(dateString)).toLocaleDateString(undefined,
                {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }
            )
        );
    }

    handleChangeTable(type) {

        this.setState({
            showTab: type,
        });
    }

    render() {

        const {
            data,
            params,
        } = this.props;

        const {
            showTab
        } = this.state;

        let tableToShow;

        // Set up the table to be shown (based on which button is chosen)
        if (data) {
            switch (showTab) {
                case 'performance':
                    tableToShow =
                        <>
                            <StandardPerformanceTable
                                data={data}
                                showTitle={false}
                                showCommonPeriod={params.showCommonPeriod}
                                commonPeriodStart={data ? data[0].stdPerformance[0].commonPeriodNAVStart : null}
                                commonPeriodEnd={data ? data[0].stdPerformance[0].commonPeriodNAVEnd : null}
                                isPortfolio={false}
                                showSinceInception={params.showSinceInception}
                                footnote={params.showPerfFootnote ? i18n.t('fundstdperformance-footnote') : ''}
                                hideCumulativeReturns={params.hideCumulativeReturns}
                                wtFundsOnly={params.wtFundsOnly}
                                sidePadding={params.sidePadding}
                                tickerTooltip={params.perfTickerToolips}
                            />
                            {params.appendPerfFootnote &&
                                <div className='footnote'>{params.appendPerfFootnote}</div>
                            }
                        </>
                    break;

                case 'details':
                    tableToShow =
                        <DetailsTable
                            data={data}
                            showTitle={false}
                            showCommonPeriod={false}
                            isPortfolio={false}
                            showPerfFootnote={params.showPerfFootnote}
                            sidePadding={params.sidePadding}
                        />;
                    break;

                case 'ratings':
                    if (!data[0].morningStarScorecard || params.esgMode) {
                        this.setState({
                            showTab: 'performance',
                        });
                    } else {
                        tableToShow =
                            <MorningstarTable
                                data={data}
                                showPerfFootnote={params.showPerfFootnote}
                                sidePadding={params.sidePadding}
                            />;
                    }
                    break;

                default:
                    tableToShow = null;
            }
        }

        // Put together the JSX for the morningstar details
        let mstarDetails = <div className="mstar-details"></div>;
        if (data && data[0].morningStarScorecard && data[0].morningStarScorecard[0].keys.indexOf('mstarRatOverall') >= 0) {

            // Repeat the star icon n times based on the mstar rating of the fund (from data)
            let mstarTitle = 'Morningstar';
            let mstarDate = '';
            let mstarIcon =
                [...Array(data[0].morningStarScorecard[0].values[data[0].morningStarScorecard[0].keys.indexOf('mstarRatOverall')])].map((item, index) =>
                    <FontAwesomeIcon className="fa" icon="star" key={index} />
                );
            if (params.esgMode) {
                mstarTitle = `Morningstar Sustainability Rating`;
                mstarDate = `(as of ${this.formatDate(data[0].morningStarScorecard[0].date)})`;
                mstarIcon =
                    [...Array(data[0].morningStarScorecard[0].values[data[0].morningStarScorecard[0].keys.indexOf('esgRating')])].map((item, index) =>
                        <FontAwesomeIcon style={{ color: 'DeepSkyBlue', marginRight: '4px' }} className="fa" icon="globe-americas" key={index} />
                    );
            }
            const mstarCategory = data[0].morningStarCategory;

            // Construct the mstar JSX
            mstarDetails =
                <div className="mstar-details">
                    <div className="mstar-text">
                        {mstarTitle}
                    </div>
                    <div className="mstar-date">
                        {mstarDate}
                    </div>
                    <div className="mstar-icon ">
                        {mstarIcon}
                    </div>
                    <div className="mstar-bar hide-mobile">
                        &nbsp;&nbsp;|
                    </div>
                    <div className="mstar-category">
                        {i18n.t('category')}: {mstarCategory}
                    </div>
                </div>;
        }

        return (

            <div className="fund-highlights">

                {/* Check if there is data before showing any of the tables */}
                {data ?
                    <Fragment>
                        <div className="select-table">
                            {mstarDetails}
                            <div className={Classnames("selection-buttons", params.esgMode ? 'esg' : '')}>
                                {data[0].morningStarScorecard && !params.esgMode &&
                                    <div className="mstar-button">
                                        <button
                                            onClick={this.handleChangeTable.bind(this, 'ratings')}
                                            className={Classnames(showTab === 'ratings' ? 'active' : 'not-active')}
                                        >
                                            {i18n.t('ratings')}
                                        </button>
                                    </div>
                                }
                                <div className="performance-button">
                                    <button
                                        onClick={this.handleChangeTable.bind(this, 'performance')}
                                        className={Classnames(showTab === 'performance' ? 'active' : 'not-active')}
                                    >
                                        {i18n.t('performance-button')}
                                    </button>
                                </div>
                                <div className="details-button">
                                    <button
                                        onClick={this.handleChangeTable.bind(this, 'details')}
                                        className={Classnames(showTab === 'details' ? 'active' : 'not-active')}
                                    >
                                        {i18n.t('fund-details')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="display-table">
                            {tableToShow}
                        </div>
                    </Fragment>

                    : null}

            </div>

        );
    }
}

export default (FundHighlights);
